<div
  class="total-raised-widget"
  [style.background-color]="backgroundColor"
  [style.color]="textColor"
  [style.font-family]="fontFamily"
  [style.font-weight]="fontWeight"
  [style.text-align]="textAlign"
  [style.border-color]="borderColor"
  [style.border-width.cqw]="borderWidth"
  [style.border-style]="borderStyle"
>
  <span [style.font-size.cqw]="fontSize" class="label">
    {{ label }}
  </span>
  <span [style.font-size.cqw]="fontSize" class="total-raised">
    {{ totalRaised | gbCurrency }}
  </span>
</div>
